import React, { useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import airconhistoryService from "../services/airconhistory.service";
import { Airconhistoryvalidationschema } from "../components/Validation";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import Loader from "../components/Loader";
import Toastmessage from "../components/Toastmessage";
import { useNavigate, useSearchParams } from "react-router-dom";
import authsService from "../services/auths.service";

const Airconhistoryevent = (props) => {
  const userinfo = authsService.userinfo();

  let navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();

  const ref = useRef();
  const [isLoaded, setIsLoaded] = useState(false);
  const [eventname, setEventname] = useState("view");

  const [ah_id, setAirconhistoryid] = useState();

  //form initial value
  const formik = useFormik({
    initialValues: {
      ah_id: "",
      client_id: "",
      aircon_id: "",
      ah_name: "",
      checked_list: "",
      service_list: "",
      total_amount: "",
      additional_amount: "",
      ah_type: "",
      ah_remark: "",
      approvedBy: "",
      servicedBy: "",
      ah_status: "",
      user_name: userinfo.user_name,
    },
    validationSchema: Airconhistoryvalidationschema,
    /*  validateOnChange: false,
         validateOnBlur: false, */
    onSubmit: (values, { resetForm }) => {
      //alert(JSON.stringify(values, null, 1));
      /*  resetForm({ values: '' }) */
    },
  });
  //use effects
  useEffect(() => {
    setAirconhistoryid(searchParams.get("ah_id"));
    if (searchParams.get("ah_id")) {
      setEventname("view");
      getAirconhistory(searchParams.get("ah_id"));
    } else {
      setEventname("create");
    }
  }, []);

  //current event
  const airconhistoryEvent = (eventname, value) => {
    if (value) {
      getAirconhistory(value);
    }
    setEventname(eventname);
  };

  //get airconhistory
  const getAirconhistory = (value) => {
    setIsLoaded(true);
    airconhistoryService
      .getAirconhistory(value)
      .then((res) => {
        if (res.data.result) {
          setIsLoaded(false);
          let data = res.data.result;
          formik.setValues({
            ah_id: data.ah_id,
            client_id: data.client_id,
            aircon_id: data.aircon_id,
            ah_name: data.ah_name,
            checked_list: data.checked_list,
            service_list: data.service_list,
            total_amount: data.total_amount,
            additional_amount: data.additional_amount,
            ah_type: data.ah_type,
            ah_remark: data.ah_remark,
            approvedBy: data.approvedBy,
            servicedBy: data.servicedBy,
            ah_status: data.ah_status,
            user_name: userinfo.user_name,
          });
        } else {
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
      });
  };
  //create airconhistory
  const createAirconhistory = () => {
    airconhistoryService
      .createAirconhistory(formik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          navigate("/airconhistory");
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        ref.current.toastlog(false, err.message);
        setIsLoaded(false);
      });
  };
  //update airconhistory
  const updateAirconhistory = () => {
    airconhistoryService
      .updateAirconhistory(formik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          airconhistoryEvent("view");
          setIsLoaded(false);
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        ref.current.toastlog(false, err.message);
        setIsLoaded(false);
      });
  };
  //delete airconhistory
  const deleteAirconhistory = (value) => {
    airconhistoryService
      .deleteAirconhistory(String(value))
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          navigate("/airconhistory");
          setIsLoaded(false);
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        ref.current.toastlog(false, err.message);
        setIsLoaded(false);
      });
  };
  // Call airconhistory clicks to request another page.
  if (isLoaded) {
    <Loader />;
  } else {
    return (
      <div className="container">
        {/*  container */}
        <div className="airconhistory-container">
          {/* form container */}
          <div className="card shadow-sm border-0 ">
            <div className="card-body ">
              <div className="d-flex">
                <h5 className="card-title p-0 m-0 me-auto">Airconhistory</h5>
                {eventname == "create" ? (
                  <></>
                ) : (
                  <div>
                    <div className="dropdown">
                      <a
                        className="btn  btn-link"
                        href="#"
                        role="button"
                        id="airconhistoryeventdropdownMenuLink"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                      </a>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="airconhistoryeventdropdownMenuLink"
                      >
                        <li>
                          <a
                            onClick={() => {
                              airconhistoryEvent("edit");
                            }}
                            className="dropdown-item"
                          >
                            Edit
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => airconhistoryEvent("delete")}
                            className="dropdown-item"
                          >
                            Delete
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
              <form onSubmit={formik.handleSubmit}>
                <div className="row">
                  {/*  profile section */}
                  <div className="col-md-12">
                    <label htmlFor="ah_type" className="form-label">
                      type
                    </label>
                    <div className="input-group col-md-6">
                      <select
                        id="ah_type"
                        {...formik.getFieldProps("ah_type")}
                        className="form-select"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                            ? true
                            : false
                        }
                        aria-label="ah_type"
                      >
                        <option value="" disabled>
                          Select type
                        </option>
                        <option value="maintenance">Maintenance</option>
                        <option value="issue">Issue</option>
                      </select>
                    </div>
                    <div>
                      {formik.touched.ah_status && formik.errors.ah_status ? (
                        <div className="error">{formik.errors.ah_status}</div>
                      ) : null}
                    </div>
                  </div>
                  {/* checked list */}
                  <div className="col-md-12">
                    <label htmlFor="checked_list" className="form-label">
                      Checked list
                    </label>
                    <div className="input-group col-md-6">
                      <textarea
                        className="form-control"
                        placeholder="Enter checked list"
                        id="checked_list"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                            ? true
                            : false
                        }
                        {...formik.getFieldProps("checked_list")}
                      ></textarea>
                    </div>
                    <div>
                      {formik.touched.checked_list &&
                      formik.errors.checked_list ? (
                        <div className="error">
                          {formik.errors.checked_list}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  {/*  service list */}
                  <div className="col-md-12">
                    <label htmlFor="service_list" className="form-label">
                      Service list
                    </label>
                    <div className="input-group col-md-6">
                      <textarea
                        className="form-control"
                        placeholder="Enter checked list"
                        id="service_list"
                        type="text"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                            ? true
                            : false
                        }
                        {...formik.getFieldProps("service_list")}
                      ></textarea>
                    </div>
                    <div>
                      {formik.touched.service_list &&
                      formik.errors.service_list ? (
                        <div className="error">
                          {formik.errors.service_list}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  {/*  reamrks */}
                  <div className="col-md-12">
                    <label htmlFor="ah_remark" className="form-label">
                      Remark
                    </label>
                    <div className="input-group col-md-6">
                      <textarea
                        className="form-control"
                        placeholder="Enter remark"
                        id="serviceah_remark_list"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                            ? true
                            : false
                        }
                        {...formik.getFieldProps("ah_remark")}
                      ></textarea>
                    </div>
                    <div>
                      {formik.touched.ah_remark && formik.errors.ah_remark ? (
                        <div className="error">{formik.errors.ah_remark}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <label htmlFor="ah_status" className="form-label">
                      status
                    </label>
                    <div className="input-group col-md-6">
                      <select
                        id="ah_status"
                        {...formik.getFieldProps("ah_status")}
                        className="form-select"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                            ? true
                            : false
                        }
                        aria-label="ah_status"
                      >
                        <option value="" disabled>
                          Select status
                        </option>
                        <option value="pending">Pending</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                    <div>
                      {formik.touched.ah_status && formik.errors.ah_status ? (
                        <div className="error">{formik.errors.ah_status}</div>
                      ) : null}
                    </div>
                  </div>
                  
                </div>
              </form>
              <div className="pt-2 pb-2">
                {eventname === "create" ? (
                  <>
                    <button
                      disabled={!formik.isValid}
                      onClick={() => createAirconhistory()}
                      className="btn btn-primary me-2"
                    >
                      Create
                    </button>
                    <button
                      onClick={formik.handleReset}
                      className="btn btn-secondary"
                    >
                      Clear
                    </button>
                  </>
                ) : eventname === "edit" ? (
                  <>
                    {" "}
                    <button
                      onClick={() => updateAirconhistory()}
                      className="btn btn-primary me-2"
                    >
                      Update
                    </button>
                    <button
                      onClick={() => airconhistoryEvent("view")}
                      className="btn btn-secondary"
                    >
                      Cancel
                    </button>
                  </>
                ) : eventname === "delete" ? (
                  <>
                    <button
                      onClick={() => deleteAirconhistory(formik.values.ah_id)}
                      className="btn btn-danger me-2 "
                    >
                      Delete
                    </button>
                    <button
                      onClick={() => airconhistoryEvent("view")}
                      className="btn btn-secondary"
                    >
                      Cancel
                    </button>
                  </>
                ) : (
                  <>
                    {/* <button onClick={() => navigate('/airconhistoryloyee')} className='btn btn-primary' >Back</button> */}
                  </>
                )}
              </div>
            </div>
          </div>
          {/*  loader and error handler */}
          {/*  {iserror === false || iserror === true ? <Alertmsg alertmsg={ismessage} type={iserror} /> : <></>} */}
          <Toastmessage ref={ref} />
          {/* <Alertmsg ref={ref}/> */}
        </div>
      </div>
    );
  }
};

export default Airconhistoryevent;
